var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_917_836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.916 11.707C15.063 11.1008 15.0174 10.4639 14.7855 9.88484C14.5537 9.30579 14.1471 8.8134 13.6223 8.47619C13.0976 8.13898 12.4808 7.97372 11.8578 8.0034C11.2347 8.03308 10.6364 8.25622 10.1461 8.64178C9.65578 9.02733 9.29784 9.55614 9.12207 10.1546C8.9463 10.7531 8.96144 11.3915 9.16539 11.9809C9.36934 12.5704 9.75195 13.0816 10.26 13.4435C10.768 13.8054 11.3762 13.9999 12 14",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 21.4849C11.464 21.483 10.9592 21.2727 10.5869 20.8999L6.34291 16.6569C5.40348 15.7174 4.7128 14.5588 4.33322 13.2857C3.95364 12.0125 3.89712 10.6648 4.16875 9.36434C4.44038 8.06386 5.03162 6.85149 5.88908 5.8367C6.74655 4.82191 7.84324 4.03664 9.08016 3.55178C10.3171 3.06693 11.6553 2.89776 12.9739 3.05954C14.2926 3.22132 15.5502 3.70896 16.6332 4.47844C17.7163 5.24792 18.5906 6.275 19.1773 7.46698C19.7641 8.65895 20.0447 9.97828 19.9939 11.3059",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 20.2002L22 22.0002",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_917_836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteMap);
export default __webpack_public_path__ + "static/media/SiteMap.807d60991ede7f28851e3a668dbc20f2.svg";
export { ForwardRef as ReactComponent };